import { useMutation } from "@tanstack/react-query";
import apiClient from "lib/api-client";
import { toast as myToast } from "react-toastify";
import { getUserDetail } from "utils/getUserDetailsHelper";

export const useShareMyBinnysCatalog = (onSuccessCallback) => {
  const mutation = useMutation({
    mutationFn: async (payload) => {
      const userId = getUserDetail("_id");
      const response = await apiClient.post(
        "/api/v1/catalogSetting/catalog-client/share-my-binys-catalog",
        { ...payload, userId }
      );
      return response.data;
    },
    onSuccess: (data) => {
      if (data?.status === 200) {
        myToast.success("Catalog shared successfully!");
        if (onSuccessCallback) onSuccessCallback(data);
      } else {
        myToast.error(data?.message || "Failed to share catalog");
      }
    },
    onError: (error) => {
      const errorMessage = error.response?.data?.message || error.message || "Something went wrong!";
      myToast.error(`Error: ${errorMessage}`);
    },
  });


  return mutation;
};

